import { getCurrentLanguage } from "@abp";
import { CATEGORY_KEYS, CATEGORY_SEO } from "../seo/seoTaxonomy.js";

export interface Category {
  id: number;
  key: string;
  nameSr: string;
  nameEn: string;
  icon: string;
  sortOrder: number;
}

export const getCategoryName = (category: Category): string =>
  getCurrentLanguage().startsWith("sr") ? category.nameSr : category.nameEn;

/**
 * Kategorije koje ruter prihvata; sve ostalo ide na /404.
 *
 * Izvedeno iz SEO rečnika jer on određuje koje se stranice prerenderuju i
 * upisuju u sitemap — dve odvojene liste bi značile da build objavi stranicu
 * koju ruter odmah preusmeri na /404.
 */
export const categoryList: string[] = CATEGORY_KEYS;

/**
 * Srpski naziv kategorije iz SEO rečnika (`labelShort`). Namerno se izvodi, a ne
 * kuca još jednom: imena su ranije živela na tri mesta ("Nokti" u bazi i rečniku,
 * "Manikir" ovde) i razilazila su se.
 */
export const categoriesMap: Record<string, string> = Object.fromEntries(
  CATEGORY_KEYS.map((key) => [key, CATEGORY_SEO[key].labelShort]),
);
